export default {
    [false]: 'fas fa-star',
    follow: 'fas fa-star',
    lurk: 'fas fa-comments',
    ignore: 'fas fa-bell-slash',
    hide: 'fas fa-eye-slash',
};
